import React from 'react';
import { Loader } from 'components/loader/loader';
/** Shown in the panel body while the assistant session is starting up. */
export const LoadingState = () => (React.createElement("div", { className: "ai-assistant__status", role: "status" },
    React.createElement(Loader, null)));
